



































































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import termCondiction from "@/models/termCondiction/termCondictioModel"
import { Quill } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";

import researchCenterType from "@/models/research/ResearchCenterType/researchCenterType.model"
@Component
export default class TermCondictionEdit extends GenericEdit<termCondiction> {
  constructor() {
    super();
    this.controller = 'TermCondictionS';
    this.model = new termCondiction();
     Quill.register("modules/imageDrop", ImageDrop);
  }
  editorOption = {
    modules: {
      toolbar: [
        ["bold", "italic", "underline"],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["clean"],
        ["link", "image", "video"]
      ],
      imageDrop: true
    },
    placeholder: "Escriba el contenido aqui..."
  };
}
